/**
 * Autogenerated mapping of core components to their component numbers
 */
export const coreComponentMappings = {
    "core::Transform": 1,
    "core::Animator": 1042,
    "core::AudioEvent": 1105,
    "core::AudioSource": 1020,
    "core::AudioStream": 1021,
    "core::AvatarAttach": 1073,
    "core::AvatarBase": 1087,
    "core::AvatarEmoteCommand": 1088,
    "core::AvatarEquippedData": 1091,
    "core::AvatarModifierArea": 1070,
    "core::AvatarShape": 1080,
    "core::Billboard": 1090,
    "core::CameraMode": 1072,
    "core::CameraModeArea": 1071,
    "core::EngineInfo": 1048,
    "core::GltfContainer": 1041,
    "core::GltfContainerLoadingState": 1049,
    "core::Material": 1017,
    "core::MeshCollider": 1019,
    "core::MeshRenderer": 1018,
    "core::NftShape": 1040,
    "core::PlayerIdentityData": 1089,
    "core::PointerEvents": 1062,
    "core::PointerEventsResult": 1063,
    "core::PointerLock": 1074,
    "core::Raycast": 1067,
    "core::RaycastResult": 1068,
    "core::TextShape": 1030,
    "core::Tween": 1102,
    "core::TweenSequence": 1104,
    "core::TweenState": 1103,
    "core::UiBackground": 1053,
    "core::UiCanvasInformation": 1054,
    "core::UiDropdown": 1094,
    "core::UiDropdownResult": 1096,
    "core::UiInput": 1093,
    "core::UiInputResult": 1095,
    "core::UiText": 1052,
    "core::UiTransform": 1050,
    "core::VideoEvent": 1044,
    "core::VideoPlayer": 1043,
    "core::VisibilityComponent": 1081
};
